import { Link } from "react-router-dom"
import { faqData } from "../../assets/constant/faq"
import { useDictionary } from "../../contexts/dictionary"
import { useState } from "react"

interface FAQData {
    question: string,
    answer: string
}

interface FAQProps {
    numberOfQuestions: number,
    columns?: number,
    qa?: FAQData[], 
}

export const FAQComponent = ({numberOfQuestions,qa,columns=1}:FAQProps) => {

    const faqFinalData = qa || faqData

    const faqs = faqFinalData.slice(0,numberOfQuestions)
    const {translate} = useDictionary()
    const widthClass = `col-lg-${12/columns} col-md-6`
    const [openQuestion,setOpenQuestion] = useState<number | undefined>()

    return (
        <section className="faq-inner-page">
          <div className="container">

            <div className="row">
                {faqs && faqs.map((faq,index) => {
                    const headingId = `heading${index}`
                    const collapseId = `collapse${index}`
                    return (
                     <div className={widthClass} key={index}>
                     <div className="faq-info faq-inner-info">
                       <div className="accordion" id="faq-details">
                         {/* FAQ Item */}
                         <div className="accordion-item">
                           <h2 className="accordion-header" id={headingId}>
                             <Link
                               to="javascript:void(0)"
                               className="accordion-button collapsed"
                               data-bs-toggle="collapse"
                               data-bs-target={`#${collapseId}`}
                               aria-expanded="false"
                               aria-controls={collapseId}
                             >
                                {translate(faq.question)}
                               
                             </Link>
                           </h2>
                           <div
                             id={collapseId}
                             className="accordion-collapse collapse"
                             aria-labelledby={headingId}
                             data-bs-parent="#faq-details"
                           >
                             <div className="accordion-body">
                               <div className="accordion-content">
                                 <p>
                                 {translate(faq.answer)}
                                 </p>
                               </div>
                             </div>
                           </div>
                         </div>
                         {/* /FAQ Item */}
                        
                       </div>
                     </div>
                   </div>
                    )
                })}
            </div>
          </div>
        </section>
    )
}